export const HYDRATE_APP = "HYDRATE_APP";
export const VENDORHYDRATE_APP = "VENDORHYDRATE_APP";
export const HYDRATE_SUCCESS = "HYDRATE_SUCCESS";
